import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, vModelSelect as _vModelSelect, withDirectives as _withDirectives, withModifiers as _withModifiers } from "vue"
import _imports_0 from '@/assets/PV Smart Planner.png'


const _hoisted_1 = { class: "navbar navbar-expand-lg navbar-light fixed-top" }
const _hoisted_2 = { class: "container-fluid" }
const _hoisted_3 = ["alt"]
const _hoisted_4 = { class: "d-flex align-items-center" }
const _hoisted_5 = ["title"]
const _hoisted_6 = ["title"]
const _hoisted_7 = { class: "language-selector" }
const _hoisted_8 = ["value"]
const _hoisted_9 = ["title"]
const _hoisted_10 = { class: "text-center mb-3" }
const _hoisted_11 = { class: "text-center mb-4" }
const _hoisted_12 = { class: "d-flex justify-content-center gap-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("nav", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        class: "navbar-brand d-flex align-items-center",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleLogoClick && _ctx.handleLogoClick(...args)))
      }, [
        _createElementVNode("img", {
          src: _imports_0,
          alt: _ctx.$t('navbar.designerLogo'),
          height: "32",
          class: "d-inline-block align-text-center"
        }, null, 8, _hoisted_3),
        _cache[10] || (_cache[10] = _createElementVNode("div", { class: "vertical-divider" }, null, -1)),
        _cache[11] || (_cache[11] = _createElementVNode("div", { style: {
            backgroundImage: 'var(--logo-image)',
            height: '32px',
            width: '80px',
            backgroundSize: 'contain',
            backgroundRepeat: 'no-repeat',
            backgroundPosition: 'center',
          } }, null, -1))
      ]),
      _createElementVNode("div", _hoisted_4, [
        (_ctx.isAuthenticated)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createElementVNode("button", {
                class: "btn btn-link nav-text",
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.handleProjectsNavigation && _ctx.handleProjectsNavigation(...args))),
                title: _ctx.$t('navbar.home')
              }, _toDisplayString(_ctx.$t("nav.projects")), 9, _hoisted_5),
              _createElementVNode("button", {
                class: "btn btn-link nav-text",
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.handleNavigation(_ctx.goToProfile))),
                title: _ctx.$t('navbar.profile')
              }, _toDisplayString(_ctx.$t("nav.account")), 9, _hoisted_6),
              _cache[12] || (_cache[12] = _createElementVNode("div", { class: "vertical-divider" }, null, -1))
            ], 64))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_7, [
          _withDirectives(_createElementVNode("select", {
            class: "form-select",
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.currentLanguage) = $event)),
            onChange: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.changeLanguage && _ctx.changeLanguage(...args)))
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.languages, (lang) => {
              return (_openBlock(), _createElementBlock("option", {
                key: lang.code,
                value: lang.code
              }, _toDisplayString(lang.name), 9, _hoisted_8))
            }), 128))
          ], 544), [
            [_vModelSelect, _ctx.currentLanguage]
          ])
        ]),
        (_ctx.isAuthenticated)
          ? (_openBlock(), _createElementBlock("button", {
              key: 1,
              class: "btn btn-link nav-icon",
              onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.handleNavigation(_ctx.handleLogout))),
              title: _ctx.$t('navbar.logout')
            }, _cache[13] || (_cache[13] = [
              _createElementVNode("i", { class: "bi bi-box-arrow-right" }, null, -1)
            ]), 8, _hoisted_9))
          : _createCommentVNode("", true)
      ])
    ]),
    (_ctx.showNavigationModal)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "modal-overlay",
          onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.showNavigationModal = false))
        }, [
          _createElementVNode("div", {
            class: "modal-content",
            onClick: _cache[8] || (_cache[8] = _withModifiers(() => {}, ["stop"]))
          }, [
            _createElementVNode("h3", _hoisted_10, _toDisplayString(_ctx.$t("navbar.navigationModal.title")), 1),
            _createElementVNode("p", _hoisted_11, _toDisplayString(_ctx.$t("navbar.navigationModal.message")), 1),
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("button", {
                onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.showNavigationModal = false)),
                class: "btn btn-secondary px-4"
              }, _toDisplayString(_ctx.$t("navbar.navigationModal.cancel")), 1),
              _createElementVNode("button", {
                onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.confirmNavigation && _ctx.confirmNavigation(...args))),
                class: "btn btn-primary px-4"
              }, _toDisplayString(_ctx.$t("navbar.navigationModal.confirm")), 1)
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}